module.exports = __webpack_public_path__ + "1a28774dc827c639e0b73eabff8ea691.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ads/facebook_sample_ad.jpg
// module id = 1609
// module chunks = 0